import BaseModel from '@/models/BaseModel'
import { required, string } from 'vue-mc/validation'

export default class Restaurant extends BaseModel {
  default () {
    return {
      name: String
    }
    // TODO default attributes of Balance Model
  }

  options () {
    return {
      methods: {
        detail: 'GET'
      }
    }
  }

  getDefaultMethods () {
    return {
      fetch: 'GET',
      save: 'POST',
      update: 'PUT',
      create: 'POST',
      patch: 'PUT',
      delete: 'POST'
    }
  }

  validation () {
    return {
      name: [ required.and(string) ]
    }
  }

  shouldPatch () {
    return true
  }

  detail (data = {}) {
    let method = this.getOption('methods.detail')
    let route = this.getRoute('detail')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    const query = Object.entries(data).reduce((acc, num, index) => {
      acc += index > 0 ? '&' : ''
      acc += `${num[0]}=${num[1]}`
      return acc
    }, '')

    url = query ? `${url}?${query}` : url
    return this.createRequest({ method, url, headers }).send()
  }

  routes () {
    // TODO routes of Balance Model
    return {
      detail: `${this.API_BASE}/v1/restaurants/{_id}`,
      fetch: `${this.API_BASE}/v1/restaurants`,
      save: `${this.API_BASE}/v1/restaurants`
    }
  }
}
